<template>
  <div class="content-scroller" :class="scrollClasses" @scroll.passive="$emit('scroll', $event)">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'content-scroller',
    props: {
      disabled: Boolean,
      visible: Boolean
    },
    computed: {
      scrollClasses () {
        return {
          'no-scroll': this.disabled,
          visible: this.visible
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .content-scroller {
    overflow: auto;

    &.no-scroll {
      overflow: hidden;
    }

    &.visible {
      overflow: visible;
    }
  }
</style>
